import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameFieldTooLong: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	detailsSectionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionEditorPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	justificationFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	justificationEditorPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refineButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	targetDateFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	targetDatePickerClear: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	targetDatePickerOpenCalendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedItemFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedItemLinkLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linksSectionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addLinkButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeLinkButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linksEmptyStateDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkUrlFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkUrlFieldPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkTextFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkTextFieldPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveLinkButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentsSectionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitterFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	receiverFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submittingTeamFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	receivingTeamFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitterPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	receiverPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submittingTeamPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	receivingTeamPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedWorkPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedWorkInvalidUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedWorkNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedWorkResolving: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impactedWorkResolvedSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityLow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityMedium: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityHigh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityHighest: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityCritical: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkCreateAllButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkDismissAllButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRowEditButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRowRemoveButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRowUntitled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRowStatusErrored: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRowStatusCreated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkMissingInfo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkProgressMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkFailureMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkSuccessMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkOverLimitMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkValidationMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkRequestFailedMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkEditModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkEditModalSubmitButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.focus-ask-create.card-title',
		defaultMessage: 'Create ask',
		description: 'Title for the create Focus Ask action card in Rovo chat',
	},
	modalTitle: {
		id: 'conversation-assistant-message-actions.focus-ask-create.modal-title',
		defaultMessage: 'Create',
		description: 'Title for the Focus Ask creation modal dialog in Rovo chat',
	},
	nameFieldTooLong: {
		id: 'conversation-assistant-message-actions.focus-ask-create.name-field-too-long',
		defaultMessage: 'Name must be less than or equal to {maxLength} characters',
		description:
			'Error message shown when the Ask name exceeds the maximum allowed length of 255 characters',
	},
	nameFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.name-field-label',
		defaultMessage: 'Name',
		description: 'Label for the name field in the Focus Ask create form',
	},
	priorityFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-field-label',
		defaultMessage: 'Priority',
		description: 'Label for the priority field in the Focus Ask create form',
	},
	detailsSectionLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.detailsSectionLabel',
		defaultMessage: 'Details',
		description: 'Section heading for compact Focus Ask details in the create card',
	},
	createButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.create-button',
		defaultMessage: 'Create',
		description: 'Button text to create a Focus Ask',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button text to cancel the Focus Ask creation',
	},
	descriptionFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.description-field-label',
		defaultMessage: 'Description',
		description: 'Label for the description field in the Focus Ask create form',
	},
	descriptionEditorPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.description-editor-placeholder',
		defaultMessage: 'What needs to be done?',
		description: 'Placeholder for description editor field in Focus Ask creation',
	},
	justificationFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.justification-field-label',
		defaultMessage: 'Justification',
		description: 'Label for the justification field in the Focus Ask create form',
	},
	justificationEditorPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.justification-editor-placeholder',
		defaultMessage: 'Why do we need it?',
		description: 'Placeholder for justification editor field in Focus Ask creation',
	},
	refineButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.refine-button',
		defaultMessage: 'Refine',
		description: 'Button text to open the refine modal for a Focus Ask',
	},
	targetDateFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.target-date-field-label',
		defaultMessage: 'Target date',
		description: 'Label for the target date field in the Focus Ask create form',
	},
	targetDatePickerClear: {
		id: 'conversation-assistant-message-actions.focus-ask-create.target-date-picker-clear',
		defaultMessage: 'Clear target date',
		description: 'Accessible label for the control that clears the Focus Ask target date field',
	},
	targetDatePickerOpenCalendar: {
		id: 'conversation-assistant-message-actions.focus-ask-create.target-date-picker-open-calendar',
		defaultMessage: 'Open calendar',
		description: 'Accessible label for the button that opens the target date calendar',
	},

	impactedItemLinkLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-item-link-label',
		defaultMessage: 'View impacted work item',
		description:
			'Accessible label for the impacted work item link in the Focus Ask suggestion preview. Describes the link purpose to screen readers.',
	},
	impactedItemFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-item-field-label',
		defaultMessage: 'Impacted item',
		description: 'Label for the impacted item text field in the Focus Ask create form',
	},
	commentFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.comment-field-label',
		defaultMessage: 'Comment',
		description: 'Label for the comment text field in the Focus Ask create form',
	},
	commentPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.comment-placeholder',
		defaultMessage: 'Add a comment',
		description: 'Placeholder for the editable comment field',
	},
	linkFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.link-field-label',
		defaultMessage: 'Link',
		description: 'Label for the read-only link prefilled from Rovo on the Focus Ask create card',
	},
	linksSectionLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linksSectionLabel',
		defaultMessage: 'Links',
		description: 'Section heading for links shown on the compact Focus Ask create card',
	},
	addLinkButtonLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.addLinkButtonLabel',
		defaultMessage: 'Add link',
		description: 'Button text for adding a link to the Focus Ask create preview card',
	},
	removeLinkButtonLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.removeLinkButtonLabel',
		defaultMessage: 'Remove link',
		description: 'Accessible label for removing a link from the Focus Ask create preview card',
	},
	linksEmptyStateDescription: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linksEmptyStateDescription',
		defaultMessage: 'Bring together the content needed to understand an ask',
		description: 'Description shown in the Links empty state on the Focus Ask create preview card',
	},
	linkUrlFieldLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linkUrlFieldLabel',
		defaultMessage: 'URL',
		description: 'Label for the link URL field on the Focus Ask create preview card',
	},
	linkUrlFieldPlaceholder: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linkUrlFieldPlaceholder',
		defaultMessage: 'https://www.example.com',
		description: 'Placeholder for the link URL field on the Focus Ask create preview card',
	},
	linkTextFieldLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linkTextFieldLabel',
		defaultMessage: 'Link text',
		description: 'Label for the link text field on the Focus Ask create preview card',
	},
	linkTextFieldPlaceholder: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.linkTextFieldPlaceholder',
		defaultMessage: 'Add a description',
		description: 'Placeholder for the link text field on the Focus Ask create preview card',
	},
	saveLinkButtonLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.saveLinkButtonLabel',
		defaultMessage: 'Add',
		description: 'Button text for saving a link on the Focus Ask create preview card',
	},
	commentsSectionLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.commentsSectionLabel',
		defaultMessage: 'Comments',
		description: 'Section heading for comments shown on the compact Focus Ask create card',
	},
	submitterFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.submitter-field-label',
		defaultMessage: 'Submitter',
		description: 'Label for the submitter user picker in the Focus Ask create form',
	},
	receiverFieldLabel: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.receiverFieldLabel',
		defaultMessage: 'Receiver',
		description: 'Label for the receiving person picker in the compact Focus Ask create card',
	},
	submittingTeamFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.submitting-team-field-label',
		defaultMessage: 'Submitting team',
		description: 'Label for the submitting team picker in the Focus Ask create form',
	},
	receivingTeamFieldLabel: {
		id: 'conversation-assistant-message-actions.focus-ask-create.receiving-team-field-label',
		defaultMessage: 'Receiving team',
		description: 'Label for the receiving team picker in the Focus Ask create form',
	},
	submitterPickerPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.submitter-picker-placeholder',
		defaultMessage: 'Select a submitter',
		description: 'Placeholder for the submitter user picker in the Focus Ask create modal',
	},
	receiverPickerPlaceholder: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.receiverPickerPlaceholder',
		defaultMessage: 'Select a receiver',
		description: 'Placeholder for the receiver user picker in the Focus Ask create modal',
	},
	submittingTeamPickerPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.submitting-team-picker-placeholder',
		defaultMessage: 'Select a submitting team',
		description: 'Placeholder for the submitting team picker in the Focus Ask create modal',
	},
	receivingTeamPickerPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.receiving-team-picker-placeholder',
		defaultMessage: 'Select a receiving team',
		description: 'Placeholder for the receiving team picker in the Focus Ask create modal',
	},
	impactedWorkPlaceholder: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-work-placeholder',
		defaultMessage: 'Paste a link to an impacted item',
		description: 'Placeholder text for the impacted work input in the Focus Ask create form',
	},
	impactedWorkInvalidUrl: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-work-invalid-url',
		defaultMessage: 'Invalid URL. Try pasting a different link.',
		description: 'Validation message shown when impacted work input is not a valid URL',
	},
	impactedWorkNotFound: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-work-not-found',
		defaultMessage: 'We couldn’t find a match. Try searching with different terms.',
		description:
			'Validation message shown when the impacted work URL cannot be resolved — covers unsupported types, wrong org, site not connected, 404s, and inaccessible items',
	},
	impactedWorkResolving: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-work-resolving',
		defaultMessage: 'Resolving link…',
		description: 'Loading hint shown while the pasted impacted work URL is being resolved',
	},
	impactedWorkResolvedSuccess: {
		id: 'conversation-assistant-message-actions.focus-ask-create.impacted-work-resolved-success',
		defaultMessage: 'Found this item — it will be linked to your ask',
		description:
			'Success message shown below the impacted work input once a pasted URL has been successfully resolved to an impacted item that the user has access to',
	},
	priorityLow: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-low',
		defaultMessage: 'Low',
		description: 'Label for low priority option in the Focus Ask priority selector',
	},
	priorityMedium: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-medium',
		defaultMessage: 'Medium',
		description: 'Label for medium priority option in the Focus Ask priority selector',
	},
	priorityHigh: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-high',
		defaultMessage: 'High',
		description: 'Label for high priority option in the Focus Ask priority selector',
	},
	priorityHighest: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-highest',
		defaultMessage: 'Highest',
		description: 'Label for highest priority option in the Focus Ask priority selector',
	},
	priorityCritical: {
		id: 'conversation-assistant-message-actions.focus-ask-create.priority-critical',
		defaultMessage: 'Critical',
		description: 'Label for critical priority option in the Focus Ask priority selector',
	},
	bulkCreateAllButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-create-all-button',
		defaultMessage: 'Create all ({count})',
		description:
			'Footer button that creates every remaining Focus Ask in the bulk card; count reflects how many rows are still pending',
	},
	bulkDismissAllButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-dismiss-all-button',
		defaultMessage: 'Dismiss all',
		description:
			'Footer button that removes every remaining Focus Ask from the bulk card without creating them',
	},
	bulkRowEditButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-row-edit-button',
		defaultMessage: 'Edit ask',
		description: 'Label for the per-row Edit icon button that opens the Focus Ask edit modal',
	},
	bulkRowRemoveButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-row-remove-button',
		defaultMessage: 'Remove from list',
		description:
			'Aria label for the per-row Remove icon button that drops a Focus Ask from the bulk batch without creating it',
	},
	bulkRowUntitled: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-row-untitled',
		defaultMessage: 'Untitled Focus Ask',
		description: 'Fallback label for a bulk Focus Ask row that has no name yet',
	},
	bulkRowStatusErrored: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-row-status-errored',
		defaultMessage: 'Failed to create',
		description: 'Status text shown on a bulk Focus Ask row whose creation request errored',
	},
	bulkRowStatusCreated: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-row-status-created',
		defaultMessage: 'Created',
		description: 'Status text shown on a bulk Focus Ask row whose creation succeeded',
	},
	bulkMissingInfo: {
		id: 'conversation-assistant-message-actions.controllers.focus-ask-create.bulkMissingInfo',
		defaultMessage: 'Missing info',
		description: 'Error message shown when the required Focus Ask name field is empty',
	},
	bulkProgressMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-progress',
		defaultMessage: 'Submitting…',
		description: 'Progress text shown while bulk asks are being created',
	},
	bulkFailureMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-failure-summary',
		defaultMessage: 'Request failed',
		description: 'Summary text shown when bulk ask creation fails',
	},
	bulkSuccessMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-success',
		defaultMessage:
			'{count, plural, one {Ask created successfully} other {Asks created successfully}}',
		description: 'Summary text shown when bulk ask creation succeeds',
	},
	bulkOverLimitMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-over-limit',
		defaultMessage: 'Too many asks. Reduce to {limit} or fewer.',
		description: 'Message shown when bulk create exceeds the per-request limit',
	},
	bulkValidationMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-validation',
		defaultMessage: '{count} asks need attention before creating.',
		description: 'Message shown when some bulk asks have validation issues',
	},
	bulkRequestFailedMessage: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-request-failed',
		defaultMessage: 'Some asks failed. Review highlighted rows and try again.',
		description: 'Message shown when a bulk create request fails',
	},
	bulkEditModalTitle: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-edit-modal-title',
		defaultMessage: 'Edit ask',
		description: 'Title for the modal used to edit a Focus Ask inside the bulk card',
	},
	bulkEditModalSubmitButton: {
		id: 'conversation-assistant-message-actions.focus-ask-create.bulk-edit-modal-submit-button',
		defaultMessage: 'Save',
		description: 'Button text that saves edits to a Focus Ask inside the bulk card',
	},
});

export default messages;
